import React, { Component } from "react";
import { Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Container, Header, Footer, IconButton } from "rsuite";
import { Heading, Message, toaster } from "rsuite";
import { LuCopy } from "react-icons/lu";
import "../../src/Entities/style.css";
import axios from "../axiosIn";
import moment from "moment/moment";


export class Home extends Component {
  constructor(props) {
    super(props);

    this.state = {
      carrera: "",
      banco: "",
      benef: "",
      tarjeta: "",
      formatoTarjeta: "",
      clabe: "",
      formatoClabe: "",
      precio: "",
      textoFecha: "",
      ubicacion: "",
      cierre: 0
    };
    
  }

  componentDidMount(){
    this.datosIniciales();
  }

  getCookie = (name) => {
    const cookies = document.cookie
      .split("; ")
      .find((row) => row.startsWith(`${name}=`));

    return cookies ? cookies.split("=")[1] : null;
  };

  setCookie = (name, value, hours) => {
    document.cookie = `${name}=${value};`;
    document.cookie = `expira=${moment().add(hours, "h").format()};`;
    document.cookie = `sessionID=${crypto.randomUUID()};`;
  };

  async copiarValor(value) {
    await navigator.clipboard.writeText(value);
    this.toast("El valor se ha copiado.");
  }

  toast(msg, type = "info") {
    toaster.push(
      <Message showIcon type={type} closable>
        <strong>{type}!</strong>
        &nbsp; {msg}
      </Message>,
      { duration: 7000, placement: "topCenter" }
    );
  }

  async datosIniciales() {
    const abortController = new AbortController();
    var url = `DatosCarrera/getDatosIniciales`;

    try {
      const response = await axios.get(url, { signal: abortController.signal });
      this.setCookie("carrera", response.data.NombrePista, 5);
      this.setCookie("pista", response.data.NombrePista, 5);
      this.setCookie("ubicacion", response.data.TextUbicacion, 5);
      this.setCookie("fecha", response.data.TextFecha, 5);
      this.setCookie("precio", response.data.Precio, 5);
      this.setCookie("logo", response.data.LogoEquipo, 5);

      this.setState({ carrera: response.data.NombrePista });
      this.setState({ precio: response.data.Precio });
      this.setState({ banco: response.data.Banco });
      this.setState({ benef: response.data.NomBeneficiario });
      this.setState({ tarjeta: response.data.NumTarjeta });
      this.setState({ formatoTarjeta: response.data.formatoTarjeta });
      this.setState({ clabe: response.data.Clabe });
      this.setState({ formatoClabe: response.data.formatoClabe });
      if (response.data.CierreEvento === 1){
        window.location.href = "#/CierreEvento";
      }
    } catch (error) {
      if (abortController.signal.aborted) {
        console.log("Data fetching cancelled");
      } else {
        // Handle error
        this.toast("Ha ocurrido un error", "error");
      }
    }
  }

  render() {
    const {
      carrera,
      precio,
      banco,
      benef,
      tarjeta,
      formatoTarjeta,
      clabe,
      formatoClabe,
      textoFecha,
      cierre
    } = this.state;
    return (
      <div
        style={{
          backgroundImage: "url(Images/backInicio.jpg)",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: "100%",
          height: "auto",
          position: "fixed",
          top: 0,
          height: "100%",
          width: "100%",
          overflow: "auto",
        }}
      >
        <div>
          {/* <br></br>
          <center>
            <Image src={`Images/Logo.png`} width={"200px"} />
          </center>
          <br></br> */}
          <React.Fragment>
            <div className="container">
              <Header
                style={{
                  backgroundColor: "#f9f7f6",
                  height: "auto",
                  padding: "20px",
                  borderRadius: "15px",
                  opacity: 0.9,
                }}
              >
                <center>
                  <Heading level={2}>CARRERA</Heading>
                  <Heading level={3}>
                    <i>"{this.state.carrera}"</i>
                  </Heading>
                </center>
                <Heading level={4}>IMPORTANTE: Antes de inciar:</Heading>
                <p></p>
                <Heading level={5}>
                  • Foto del participante
                  <br />
                  • Foto de su voucher de pago
                  <br />
                  <b>• Precio de la carrera (${this.state.precio}):</b>
                  <br />
                  <br />
                  Banco: <b>{banco}</b>
                  <br />
                  Beneficiario: {benef}
                  <br />
                  <br />
                  Tarjeta: <b>{formatoTarjeta}</b>&nbsp;&nbsp;
                  <IconButton appearance="link" style={{fontSize: '18px'}} icon={<LuCopy></LuCopy>} 
                  onClick={() => this.copiarValor(`${tarjeta}`)}></IconButton>
                  <br />
                  <br></br>
                  {/* <br />
                  {/* Cuenta: <b>150 28 93184</b>&nbsp;&nbsp; */}
                  Clabe: <b>{formatoClabe}</b>&nbsp;&nbsp;
                  <IconButton appearance="link" style={{fontSize: '18px'}} icon={<LuCopy></LuCopy>} onClick={() => this.copiarValor(`${clabe}`)}></IconButton>
                  <br />
                  <br />
                  <p>Recuerda tomar foto de tu voucher para el registro.</p>
                  <h4 style={{ backgroundColor: "yellow" }}>
                    * IMPORTANTE: En el concepto de la transferencia anota tu
                    NOMBRE COMPLETO, para una identificación más rapida.
                  </h4>
                  <p></p>
                </Heading>
              </Header>
              <Footer>
                <br></br>
                <Link className="btn btn-primary w-100" to="/AceptaResponsiva">
                  Iniciar Registro
                </Link>
                {/* <NavLink className="btn btn-primary w-100" to="/registro">
                  Iniciar Registro
                </NavLink>
                <Routes>
                  <Route path="/registro" element={<Registro />} />
                </Routes> */}
              </Footer>
              <br></br>
            </div>
          </React.Fragment>
        </div>
      </div>
    );
  }
}
